<template>
  <ContentPage back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">Users</div>
    </template>

    <SearchBar v-model="searchFilter">
      <template #extra_buttons>
        <FilterDialog />
        <UserDialog />
      </template>

      <template #results>
        <div class="text-center grey--text text--darken-3" style="font-size: 12px;">
          {{ users.length }} Users ({{ usersFilters.inactive ? 'all' : 'active' }})
        </div>
      </template>

    </SearchBar>

    <v-data-table
      :headers="headers"
      :items="filtered_users"
      :item-class="rowClass"
      :mobile-breakpoint="0"
      :sort-by="'name'"
      hide-default-footer disable-pagination
      class="rounded-lg"
      @click:row="userClick"
    >
    <template #item.role="{ item }">
        <v-icon color="primary" class="pb-1" small v-if="item.role==='admin'">
          mdi-crown
        </v-icon>
      </template>

      <template #item.name="{ item }">
        {{ item.name }}
        <v-icon color="#F47C02" small v-if="item.default_rewards_user">mdi-qrcode</v-icon>
      </template>

      <template #item.has_w9="{ item }">
        <v-icon color="blue darken-1" class="pb-1" small v-if="item.has_w9">mdi-check</v-icon>
      </template>

      <template #item.logged_in="{ item }">
        {{ formatLastLogin(item) }}
      </template>
    </v-data-table>
  </ContentPage>
</template>

<script>
import { ContentPage } from '@/components/pages'
import SearchBar from '@/components/SearchBar'
import UserDialog from './Show/dialogs/User'
import FilterDialog from './FilterDialog.vue'
import { mapActions, mapGetters } from 'vuex'
import { formatDate } from '@/lib/formatters'

export default {
  name: 'UserListView',

  components: { ContentPage, SearchBar, UserDialog, FilterDialog },

  data: () => ({
    searchFilter: '',

    headers: [
      {
        align: 'center',
        sortable: false,
        value: 'role',
        class: 'pl-2 pr-0',
        cellClass: 'pl-2 pr-0',
      },
      {
        text: 'User',
        align: 'start',
        value: 'name',
        class: 'px-1',
        cellClass: 'px-1 text-no-wrap',
      },
      {
        text: 'Recent Referrals',
        align: 'end',
        value: 'last_30d_referrals',
        class: 'px-1',
        cellClass: 'px-1 text-no-wrap',
      },
      {
        text: 'W-9', 
        align: 'center',
        value: 'has_w9',
        sortable: false,
        class: 'px-1 text-no-wrap',
        cellClass: 'px-1 text-no-wrap'
      },
      {
        text: 'Last Login', 
        align: 'center',
        value: 'logged_in',
        sortable: false,
        class: 'pl-1 pr-2',
        cellClass: 'pl-1 pr-2 text-no-wrap'
      },
    ]
  }),
  
  computed: {
    ...mapGetters('users', { users: 'all' }),
    ...mapGetters('filters', ['usersFilters']),

    filtered_users() {
      if (!this.searchFilter) {
        return this.users
      } else {
        const filt = this.searchFilter.toLowerCase()
        return this.users.filter(
          user => user.name.toLowerCase().includes(filt)
        )
      }
    },
  },
  
  watch: {
    usersFilters(newVal) {
      this.loadAll( newVal )
    }
  },

  methods: {
    ...mapActions('users', ['loadAll']),
    ...mapActions('filters', ['loadUsersFilters']),

    formatDate,

    rowClass(item) {
      if(!item.active) return 'grey--text' 
    },
  
    // expects a user
    formatLastLogin: ({ logged_in, last_login }) => {
      if (logged_in) return 'Now'

      return last_login ?formatDate(last_login) : 'Never'
    },

    userClick(user) {
      this.$router.push({
        name: 'you/users/show',
        params: { user_id: user.user_id },
      })
    },
  },

  async created() {
    const changed = await this.loadUsersFilters()
    if(!changed) {
      const result = this.loadAll(this.usersFilters)

      this.error = !result.ok
    }
  }
}
</script>

